import { Google } from '../analytics/index.js';

/**
 * @summary Sends a Google clickEvent for Selling Your Car CTAs in Selling Your Car Module (AT HP Redesign)
 */
export async function sellingYourCarCTAClick(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    data
  } = metadata;
  const {
    category
  } = data;
  Google.sendClickEvent({
    eventElement: category,
    eventAction: 'click',
    eventResult: category === 'ico' ? 'cta::homepage::start-your-offer' : 'cta::center_syc::place-an-ad',
    eventNonInteractive: false
  }, option);
  return {};
}
export default {
  sellingYourCarCTAClick
};